
export const disabledServiceWorkerUrls = [
    "vodapay.quickbus.com",
    "vodapay-dev.quickbus.com",
    "vodapay-staging.quickbus.com",
    "jumia.quickbus.com",
    "jumia-dev.quickbus.com"
]